import { render, staticRenderFns } from "./ClaimUser.vue?vue&type=template&id=3a132694&"
import script from "./ClaimUser.vue?vue&type=script&lang=js&"
export * from "./ClaimUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports